<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Konfiguracja - Nowa definicja faktury <small class="text-red-400 text-xs">(Wszystkie pola wymagane)</small></h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-3/4">

        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <multiselect-input v-model="form.magazyn" :error="form.errors.magazyn" class="pr-6 pb-8 w-full lg:w-1/2" :options="magazyny" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Domyślny magazyn dla nowej definicji faktury" />

            <multiselect-input v-model="form.forma_platnosci" :error="form.errors.forma_platnosci" class="pr-6 pb-8 w-full lg:w-1/2" :options="formy_platnosci" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Domyślny forma płatności" />

            <text-area-input v-model="form.uwagi" :error="form.errors.uwagi" class="pr-6 pb-8 w-full lg:w-1/2" label="Uwagi" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.can['update configs']">
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Zapisz konfigurację</loading-button>
          </div>
            
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Konfiguracja - Nowa definicja faktury' },
  components: {
    LoadingButton,
    TextAreaInput,
    MultiselectInput
  },
  layout: Layout,
  remember: 'form',
  props: {
    config: Object,
    magazyny: Array,
    formy_platnosci: Array
  },
  data() {
    return {
      form: this.$inertia.form({
        magazyn: this.config.magazyn,
        forma_platnosci: this.config.forma_platnosci,
        uwagi: this.config.uwagi
      })
    }
  },
  methods: {
    update() {
      this.form.put(this.route('configs.new_facture.update'))
    },
  },
}
</script>
